// Pitch Deck Auditor — public surface.
// Data layer
export * from '@src/components/sco/PitchDeckAuditor/gql/operations'
export * from '@src/components/sco/PitchDeckAuditor/model/types'
export * from '@src/components/sco/PitchDeckAuditor/model/ratingMeta'
export * from '@src/components/sco/PitchDeckAuditor/model/adapt'
export * from '@src/components/sco/PitchDeckAuditor/hooks/useScoPitchDeck'
export * from '@src/components/sco/PitchDeckAuditor/hooks/usePitchDeckStaticOptions'
export * from '@src/components/sco/PitchDeckAuditor/hooks/useAcceptRewrite'
export * from '@src/components/sco/PitchDeckAuditor/hooks/usePitchDeckUpload'
// Components
export * from '@src/components/sco/PitchDeckAuditor/PitchDeckWorkspace'
export * from '@src/components/sco/PitchDeckAuditor/PitchDeckEmbedded'
export * from '@src/components/sco/PitchDeckAuditor/PitchDeckAuditorShell'
export * from '@src/components/sco/PitchDeckAuditor/start/PitchDeckStart'
export * from '@src/components/sco/PitchDeckAuditor/start/PitchDeckNeedsUpload'
export * from '@src/components/sco/PitchDeckAuditor/start/PitchDeckList'
